module.exports = __webpack_public_path__ + "img/Quiz.efe441b0.svg";